import { useContext, useEffect, useRef } from 'react';
import { storeUser } from './AuthActions'
import { userManager as usermanager } from './App';
import { getAccessToken } from './ProtectedRoute';
import { signout } from './App';

export default function AuthProvider({ userManager: manager, store, children }) {
    const timer = useRef<any>(null);
    let userManager = useRef<any>(null);

    useEffect(() => {
        userManager.current = manager

        const onUserLoaded = (user) => {
            console.log(`user loaded: ${user}`)
            store.dispatch(storeUser(user))
            console.log()
            resetTimer()
        }

        const onUserUnloaded = () => {
            console.log(`user unloaded`)
        } 

        const resetTimer = () => {
            if (timer.current) {
                clearTimeout(timer.current);
                timer.current = null;
            }
            if (getAccessToken()) {
                timer.current = setTimeout(signout, 60 * 60000);
            }
        };

        window.onload = resetTimer;
        document.onmousemove = resetTimer;
        document.onkeyup = resetTimer;
        document.onkeydown = resetTimer;

        const onAccessTokenExpiring = async () => {
            usermanager.signinSilent();
            console.log(`user token expiring...`);
            console.log('Token-expiring and logging out...');
        }

        const onUserSignedOut = () => {
            console.log(`user signed out`)
        }

        // events for user
        //@ts-ignore
        userManager.current.events.addUserLoaded(onUserLoaded)

        //@ts-ignore
        userManager.current.events.addUserUnloaded(onUserUnloaded)
        //@ts-ignore
        userManager.current.events.addAccessTokenExpiring(onAccessTokenExpiring)
        //@ts-ignore
        userManager.current.events.addUserSignedOut(onUserSignedOut)

        // Specify how to clean up after this effect:
        return function cleanup() {
            //@ts-ignore
            userManager.current.events.removeUserLoaded(onUserLoaded);
            //@ts-ignore
            userManager.current.events.removeUserUnloaded(onUserUnloaded);
            //@ts-ignore
            userManager.current.events.removeAccessTokenExpiring(onAccessTokenExpiring)
            //@ts-ignore
            userManager.current.events.removeUserSignedOut(onUserSignedOut)
        };
    }, [manager, store]);


    return (
        <>
            {children}
        </>
    )
}
